module.exports = __webpack_public_path__ + "img/lnfdi.3795cf10.png";